import $ from "cash-dom";
import { gsap } from "gsap";
import getCssVarValue from "./function_get-css-var-value";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default (function () {
    var selector = "[data-drift]";
    var registered = false;

    function init() {
        if (!$(selector).length) return;
        // if (window.innerWidth < 768) return;

        jdmn.log("function_drifting-type.js initialized", "green");

        if (!registered) {
            gsap.registerPlugin(ScrollTrigger);
            registered = true;
        }

        $(selector).each(function () {
            var $instance = $(this);
            var $trigger = $instance.parents(".layout");

            var distance = window.innerWidth / 2;
            var inbound = $instance.data("drift") === "in";
            var mod = $instance.index() % 2 === 0 ? 1 : -1;
            var offset = ($instance.index() * distance) / 4;

            var scrollTrigger = {
                trigger: $instance.parent()[0],
                start: inbound ? `center-=${window.innerHeight + offset} center` : "center center",
                end: inbound ? "center center" : `center+=${window.innerHeight * 2 + offset} center`,
                scrub: 1,
            };

            if (inbound) {
                gsap.from($instance[0], {
                    x: -distance * mod,
                    opacity: 0,
                    // ease: "back.inOut(3)",
                    scrollTrigger: scrollTrigger,
                });
            } else {
                gsap.to($instance[0], {
                    x: distance * mod,
                    opacity: 0,
                    // ease: "back.out(3)",
                    scrollTrigger: scrollTrigger,
                });
            }
        });
    }

    $(document).ready(init);
})();
